<template>
    <div class="navbar navbar-expand-lg py-2 z-2" v-if="navbarHidden">
        <div class="container">
            <div class="d-flex align-items-center p-2 p-md-0">
                <div class="p-4 border border-2 rounded-circle me-2 profile-image" :style="{
					'background-image': `linear-gradient(rgba(0,0,0,0.4), rgba(0,0,0,0.4)), url(${'https://i.ibb.co/gdYKsrd/MrBud.png'})`
				}"></div>
                <h3 class="name display-3 fs-2 fw-bold my-0">Rezaar</h3>
            </div>
            <div class="mx-auto d-none d-lg-flex">
                <ul class="navbar-nav p-3">
                    <li class="mx-1"><a class="btn p-2 border-0 bg-dark text-white">Home</a></li>
                    <li class="mx-1"><a class="btn p-2 border-0 bg-dark text-white">About</a></li>
                    <li class="mx-1"><a class="btn p-2 border-0 bg-dark text-white">Projects</a></li>
                    <li class="mx-1"><a class="btn p-2 border-0 bg-dark text-white">Contact</a></li>
                </ul>
            </div>
            <div>
                <small class="text-white fw-lighter"><i>A constant work in progress...</i></small>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "NavComp",
    computed: {
        navbarHidden(){
            return !this.$store.state.navbarHidden;
        }
    }
}
</script>
<style scoped>
.name {
    -webkit-text-stroke: 1px white;
    color: transparent;
    font-family: Arial, Helvetica;
}
.navbar {
    background: transparent !important;
}
.profile-image {
	background-position: center;
	background-size: 80%;
	background-repeat: no-repeat;
}
</style>